import { createLocalStorageStateHook } from "use-local-storage-state";

export const useSelectedTheaterId = createLocalStorageStateHook<string>(
  "selectedTheaterId",
  ""
);
